import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import BottomNav from '../components/BottomNav';
import BNNBg from '../assets/bnn-bg.png';
import { getDeputyTitleFromRouteId } from '../utils/deputy';
import { useParams } from 'react-router-dom';
import { getOrgStructureImage } from '../utils/organization';

export default function OrganizationPage() {
  const { id } = useParams();
  const { t, i18n } = useTranslation();

  const lang = i18n.language as 'id' | 'en';

  return (
    <div className="min-h-screen bg-darkBlue flex text-white">
      <div className="flex-1 bg-darkerBlue pt-60 pb-40 pl-60 pr-40">
        <Header />
        <div className="mt-[100px]">
          <div className="text-base text-white font-medium tracking-[2px] uppercase">
            {getDeputyTitleFromRouteId(id, t)}
          </div>
          <hr className="mt-20 mb-26 w-64" />
          <div className="text-title text-blue uppercase font-bold">
            {t('structure')}
          </div>
        </div>
      </div>

      <div className="flex-[2.7] px-64 relative z-[1]">
        <img
          src={getOrgStructureImage(id)[lang]}
          alt="org-tree"
          className="mx-auto mt-96 mb-64 max-h-[750px]"
        />
      </div>

      <img
        src={BNNBg}
        alt="bnn-logo"
        className="absolute right-60 bottom-36 z-0"
      />

      <BottomNav page={0} totalPage={1} />
    </div>
  );
}
